import INTOUCH_API from "../../services/Api";
import { useEffect } from "react";
import Game from "../../store/Game";
import useCurrentGame from "../../hooks/useCurrentGame";
import useCurrentUserData from "../../hooks/useCurrentUserData";
import useBrowserStorage from "../../hooks/useBrowserStorage";
import { TEMPORARY_ID_KEY } from "../../utils/constants";
import useAuth from "../../hooks/useAuth";

export default function useController() {
  const { getCurrentGame } = useCurrentGame();
  const { getItem } = useBrowserStorage();
  const { token } = useAuth();
  const { getUserData } = useCurrentUserData();

  const getCards = async () => {
    if (Game.cards.length) return;
    const requestData = {
      event: "questions_cards",
      payload: null,
    };
    await Game.getCards(requestData.event, requestData.payload, () => {});
  };

  const onFeedbackSwipe = async (answerInfo) => {
    const game = getCurrentGame();
    const currentUser = getUserData();
    const temporaryUserId = getItem(TEMPORARY_ID_KEY);
    const answerData = {
      gameId: game.id,
      answer: answerInfo.answer,
      questionId: answerInfo.id,
    };
    if (token) {
      answerData.userId = currentUser.id;
    } else {
      answerData.temporaryUserId = temporaryUserId;
    }
    const requestData = {
      event: "answers_edit",
      payload: answerData,
    };
    await INTOUCH_API.requestManager(
      requestData.event,
      requestData.payload,
      (response) => {},
      (error) => {}
    );
  };

  useEffect(() => {
    getCards();
    return () => {
      Game.removeCards();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    onFeedbackSwipe,
  };
}
